import { render, staticRenderFns } from "./Vente.vue?vue&type=template&id=121de562&"
import script from "./Vente.vue?vue&type=script&lang=ts&"
export * from "./Vente.vue?vue&type=script&lang=ts&"
import style0 from "./Vente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports